// extracted by mini-css-extract-plugin
export var SVGWrapper = "index-module--SVGWrapper--a905a";
export var iconContainer = "index-module--iconContainer--bc2bf";